'use strict';

module.exports = function GoogleRTFile(config, collaborationModel, ajaxProvider) {
	if (!config || !config.googleAppId || !collaborationModel || !ajaxProvider) {
		throw new Error('invalid-args');
	}
	const self = this,
		nativeMimeType = 'application/vnd.google-apps.drive-sdk.' + config.googleAppId,
		getPlainAggregate = function (googleMMProfile, googleFileInfo) {
			return ajaxProvider.request({
				type: 'GET',
				url: 'https://www.googleapis.com/drive/v3/files/' + googleFileInfo.id + '?alt=media&supportsTeamDrives=true',
				headers: {
					'Authorization': 'Bearer ' +  googleMMProfile.providerProfile.token
				}
			})
			.then(JSON.parse);
		};
	self.getAggregate = function (googleMMProfile, googleFileInfo) {
		if (!googleMMProfile || !googleFileInfo) {
			throw new Error('invalid-args');
		}
		if (googleFileInfo.mimeType === nativeMimeType) {
			return Promise.reject('realtime-unavailable');
		} else if (googleFileInfo.mimeType === 'application/vnd.mindmup' || (googleFileInfo.name && googleFileInfo.name.endsWith('.mup'))) {
			return getPlainAggregate(googleMMProfile, googleFileInfo);
		} else {
			return Promise.reject('invalidFileType');
		}
	};

	self.getNativeMimeType = () => `${nativeMimeType},application/vnd.mindmup,application/octet-stream,application/json`;
};
